import React, { useEffect } from "react";
import addUploadIcon from "../../assets/Icons/addUploadIcon.svg";
import addBulkUploadIcon from "../../assets/Icons/addBulkUploadIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";

import AdminAppBar from "./AdminAppBar";
import BackArrow from "../Form/BackArrow/BackArrows.jsx";
import AppBar from "../leadComponent/AppBar.jsx";
import { toast, ToastContainer } from "react-toastify";
import LeadUploadPanel from "../CommonComponents/LeadUploadPanel.jsx";

const AdminLeadUploadPanel = () => {
  const navigate = useNavigate();

  const handleManualClick = () => {
    if (userRole === "Admin") {
      navigate("/admin/lead-upload/manual");
    } else if (userRole === "BOD") {
      navigate("/bod/lead-upload/manual");
    } else if (userRole === "Lead Uploader")
      navigate("/lead-uploader/lead-upload/manual");
  };

  const handleBulkUploadClick = () => {
    if (userRole === "Admin") {
      navigate("/admin/lead-upload/bulk");
    } else if (userRole === "BOD") {
      navigate("/bod/lead-upload/bulk");
    } else if (userRole === "Lead Uploader")
      navigate("/lead-uploader/lead-upload/bulk");
  };
  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message, {
        position: "top-center",
        theme: "light",
        className: "absolute top-20",
      });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;

  const handleBack = () => {
    if (userRole === "Admin") {
      navigate("/admin/lead-db");
    } else if (userRole === "CMO") {
      navigate("/cmo/lead-db");
    } else if (userRole === "Lead Uploader") {
      navigate("/lead-uploader");
    } else if (userRole === "BOD") {
      navigate("/bod/dashboard");
    }
  };
  return (
    <div className=" h-screen  bg-appGrayBackground pt-28 xl:pt-32 2xl:pt-24 lg:pt-20  ">
      {userRole === "Lead Uploader" && <AppBar />}
      <ToastContainer />

      <div className=" container  w-full  h-full  ">
       <LeadUploadPanel />
      </div>
    </div>
  );
};

export default AdminLeadUploadPanel;
